import React from 'react'

import { CircleLoading } from 'src/components/ui/loading/CircleLoading'

import { Container } from './styles'

export const LoadingPage: React.FC = () => {
  return (
    <Container>
      <CircleLoading color="var(--brand)" size="8rem" />
      <p>Carregando...</p>
    </Container>
  )
}
